var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkInGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.744 16.985H.074V5.57h3.67v11.416zM1.91 3.971c-.506 0-.992-.208-1.35-.58A2.016 2.016 0 010 1.993C0 1.468.201.964.56.593c.357-.37.843-.58 1.349-.58.269-.03.541-.003.799.082s.495.225.697.412c.202.187.363.416.474.672a2.054 2.054 0 010 1.627 1.99 1.99 0 01-.474.672c-.202.187-.44.327-.697.412-.258.085-.53.113-.8.081zm15.075 13.014h-3.67V10.86c0-1.535-.527-2.537-1.86-2.537a1.97 1.97 0 00-1.152.384 2.086 2.086 0 00-.733.999 2.623 2.623 0 00-.122.925v6.343H5.776V5.557h3.67v1.61c.334-.6.82-1.093 1.404-1.429a3.567 3.567 0 011.913-.473c2.447 0 4.221 1.636 4.221 5.15v6.57z",
    fill: "url(#linkIn-gradient_svg__paint0_linear_1924_26446)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linkIn-gradient_svg__paint0_linear_1924_26446",
    x1: 9.491,
    y1: 31.898,
    x2: 23.236,
    y2: 25.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#01D6B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#218FEE"
  })))));
}

export default SvgLinkInGradient;